module.exports = __webpack_public_path__ + "static/img/ys_btn2.6c5e3ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/ys_btn2.png
// module id = gAsI
// module chunks = 7